import axios from 'axios'

const baseURL = process.env.VUE_APP_SUPPORT_API_BASE_URL ? process.env.VUE_APP_SUPPORT_API_BASE_URL : 'https://support-api.primeearnapp.dev'

const axiosSupportObject = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

axiosSupportObject.updateAuthentication = function (apiToken) {
  axiosSupportObject.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`
}

axiosSupportObject.removeAuthentication = function () {
  delete (axiosSupportObject.defaults.headers.common['Authorization'])
}

axiosSupportObject.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default axiosSupportObject